<template>
	<el-row :gutter="10" class="stat-numbers common" style="font-family: Bebas Neue;">
		<el-col :span="6"
			><router-link :to="{ name: 'classgradeManagement' }">
				<div class="number-block number-block-class">
					<div class="caption">
						<span>管辖班级 </span
						><svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-iconoutlinearrowenter"></use>
						</svg>
					</div>
					<p>{{ mgnClassNumber }}<span>个</span></p>
				</div></router-link
			>
		</el-col>
		<el-col :span="6"
			><router-link :to="{ name: 'studentManagement' }">
				<div class="number-block number-block-student">
					<div class="caption">
						<span>管辖学生</span
						><svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-iconoutlinearrowenter"></use>
						</svg>
					</div>
					<p>{{ mgnStudentNumber }}<span>名</span></p>
				</div></router-link
			>
		</el-col>
		<el-col :span="6"
			><router-link :to="{ name: 'testManagement', params: { sbid: subject_id } }">
				<div class="number-block number-block-test">
					<div class="caption">
						<span>进行中评测</span
						><svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-iconoutlinearrowenter"></use>
						</svg>
					</div>
					<p>{{ wipTestNumber }}<span>个</span></p>
				</div></router-link
			>
		</el-col>
		<el-col :span="6"
			><router-link :to="{ name: 'declarationList', params: { sbid: subject_id } }">
				<div class="number-block number-block-declaration">
					<div class="caption">
						<span>待处理申报</span
						><svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-iconoutlinearrowenter"></use>
						</svg>
					</div>
					<p>{{ pendingDeclarationNumber }}<span>个</span></p>
				</div></router-link
			>
		</el-col>
	</el-row>
</template>

<script>
export default {
	data() {
		return {
			subject_id: null,
			mgnClassNumber: '-',
			mgnStudentNumber: '-',
			wipTestNumber: '-',
			pendingDeclarationNumber: '-'
		}
	},
	created() {
		if (
			this.$store.state.user.userInfo &&
			this.$store.state.user.userInfo.type == this.$api.account.types.TEACHER.value
		) {
			// 学科
			this.subject_id = this.$store.state.user.userInfo.teacher.subject_id
			// 数字
			this.$api.teacher.show(this.$store.state.user.userInfo.id).then(res => {
				this.mgnClassNumber = res.summary.classgrade_count
				this.mgnStudentNumber = res.summary.student_count
			})

			this.$api.test
				.list(true, true, false, {
					paginate: {
						size: 1
					}
				})
				.then(res => {
					this.wipTestNumber = res.meta.total
				})

			this.$api.user
				.listDeclaration(0, {
					pov: 1,
					filterBy: {
						state: this.$api.declaration.state.IN_PROGRESS.value
					},
					paginate: {
						size: 1
					}
				})
				.then(res => {
					this.pendingDeclarationNumber = res.meta.total
				})
		}
	}
}
</script>

<style></style>
